import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { colours, SPACING } from '@qflow/theme'

import { usePassback, useResponsive } from 'portal/lib/hooks'
import { Flag } from 'portal/lib/primitives/icons/Flag'
import { Spacer } from 'portal/lib/primitives/layout'
import { Label } from 'portal/lib/primitives/text'

import { OptionButton, TrayItemContainer } from './primitives'

export function NavDropdownOption({
  label,
  Icon,
  uri = '#',
  useFlags,
  country,
  onClick,
  onClickPassbackValue,
  ...props
}) {
  const handleClick = usePassback(onClick, onClickPassbackValue)

  const { isMobile } = useResponsive()

  return (
    <TrayItemContainer>
      <StyledLink {...props} to={uri} onClick={handleClick}>
        <OptionButton
          forwardedAs="div"
          css={ButtonCSS}
          mobilePadding={isMobile}
        >
          {Icon && <Icon />}
          {Icon && <Spacer.Tiny />}

          {useFlags && country && (
            <FlagWrapper>
              <Flag country={country} />
            </FlagWrapper>
          )}

          <Label isChild noWrap>
            {label}
          </Label>
        </OptionButton>
      </StyledLink>
    </TrayItemContainer>
  )
}

NavDropdownOption.propTypes = {
  label: PropTypes.string.isRequired,
  Icon: PropTypes.elementType,
  uri: PropTypes.string,
  useFlags: PropTypes.bool,
  country: PropTypes.string,
  onClickPassbackValue: PropTypes.any,
  onClick: PropTypes.func
}

const StyledLink = styled(Link)`
  width: 100%;
  text-decoration: none;
  ${props =>
    props.selected &&
    css`
      background-color: ${colours.PALE_TEAL};
    `}
`
const FlagWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
  width: 18.667px;
`
const ButtonCSS = css`
  width: 100%;
  padding: 0.5rem 1rem;

  ${({ mobilePadding }) =>
    mobilePadding &&
    css`
      padding-top: ${SPACING.SMALL};
      padding-bottom: ${SPACING.SMALL};
    `}
`
